import { render, staticRenderFns } from "./navLesson.vue?vue&type=template&id=6b3f1880&"
import script from "./navLesson.vue?vue&type=script&lang=js&"
export * from "./navLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports